import React, { useState } from "react";
import PageHero from "../../components/PageHero";
import Pagination from "../../components/Pagination";

export default function Videos({ siteContent }) {
  const { title, headContent, videos, image } = siteContent

  const replaceUrl = (value) => {
    const url = value.replace("watch?v=", "embed/")
    const id = url.split("https://www.youtube.com/embed/")

    return {
      id: id[1],
      url
    }
  }

  const perPage = 4;
  const totalPages = Math.ceil(videos.length / perPage);

  const [page, setPage] = useState(1);

  const start = (page - 1) * perPage;
  const items = videos.slice(start, start + perPage);

  return (
    <>
      <PageHero
        title={title}
        subtitle={headContent}
        img={image?.url}
      />

      <main className="container main">
        <section className="section">
          <div className="videoGrid">
            {items.map((v) => (
              <article className="vcard" id={replaceUrl(v.url).id} key={replaceUrl(v.url).id}>
                <div className="vcard__frame">
                  <iframe
                    src={replaceUrl(v.url).url}
                    title={v.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
                <div className="vcard__title">{v.title}</div>
              </article>
            ))}
          </div>

          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </section>
      </main>
    </>
  );
}